import script from "./GoCancelArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./GoCancelArrow.vue?vue&type=script&setup=true&lang=js"

import "./GoCancelArrow.vue?vue&type=style&index=0&id=03093c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03093c86"]])

export default __exports__